export default __webpack_public_path__ + "static/font-ac295b8326354863d425643156443ba7.woff2";